<template>
  <v-bottom-navigation
    v-if="$auth.check() && (!['Err404', 'NewExecution', 'ContinueExecution', 'ReviewExecution', 'ExecuteTask', 'ContinueTask'].includes($route.name) && $route.name)"
    :color="this.$vuetify.theme.isDark? 'secondary' : 'secondary'"
    app
    grow
    shift
    max-height="45"
  >
    <v-btn
      v-for="(link,i) in mobileLinks"
      :key="i"
      :to="link.to"
      class="pb-2"
      
      v-show="$can(link.permission.act,  link.permission.on)"
    >
      <v-icon>{{link.icon}}</v-icon>
      <span>{{link.text}}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import links from "@/mixins/links";
export default {
  mixins: [links]
};
</script>